import React from "react";

import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import RefreshRoundedIcon from "@material-ui/icons/RefreshRounded";

import EmptyState from "designV2/components/EmptyState";
import Button from "designV2/components/Button";

/**
 * ErrorPage - what a screen shows when its query came back empty-handed.
 *
 * Rendered by around seventy pages, most of them inside their own page
 * shell, so it stays a block rather than a full-height layout of its
 * own. Both props are optional: every existing caller renders it bare.
 *
 * @param {Object} props
 * @param {string} props.message - Replaces the generic explanation
 * @param {Function} props.onRetry - Runs instead of reloading the page
 */
const ErrorPage = ({ message, onRetry }) => (
  <EmptyState
    icon={<ErrorOutlineIcon />}
    title="We could not load this"
    message={
      message || "Something went wrong fetching the data. Refreshing usually sorts it out."
    }
    action={
      <Button
        variant="secondary"
        icon={<RefreshRoundedIcon />}
        onClick={onRetry || (() => window.location.reload())}
      >
        Refresh
      </Button>
    }
  />
);

export default ErrorPage;
